import {
  Alert,
  Col,
  Collapse,
  CollapseHeader,
  FormSection,
  Row,
  Switch,
} from "melco-ui";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { DesignTokens } from "melco-ui";
import { AllCountrySelect } from "../../common/AllCountrySelect";
import { AllProductSelect } from "../../common/AllProductsSelect";

import { UserRoleAssignActionButton } from "../UserRoleAssignActionButton";
import {
  TransformedBasicRoles,
  useUserAccountGetPermission,
} from "../../../hooks/users/useUserAccountGetPermission";
import {
  MelcoModelsPermissionsSubListItem,
  VerticalForm,
} from "melco-shared-logic";
import { RolesSelect } from "../../common/RolesSelect";
import { useGetRoles } from "../../../hooks/roles/useGetRoles";
import { ADMIN, CUSTOM } from "../../../helper/usersHelper";
import styled from "styled-components";

type UserPermissionsPropTypes = {
  userId: string;
  productCode: string;
};

const CollapseWrapper = styled.div`
  min-width: 100%;
  margin: 5px;
`;

const RestrictDivWrapper = styled.div`
  padding: 5px 50px;
`;
export const UserPermissions: React.FC<UserPermissionsPropTypes> = ({
  userId,
  productCode,
}) => {
  const { t } = useTranslation();
  const { spacings } = DesignTokens;
  const [selectedRoleType, setSelectedRoleType] = useState<any>();
  const [allRoles, addAllRoles] = useState<TransformedBasicRoles | undefined>();
  const { data } = useUserAccountGetPermission(userId, productCode);

  const [localpermissions, setLocalpermissions] =
    useState<MelcoModelsPermissionsSubListItem[]>();

  const [userPermissions, setUserPermissions] = useState<
    TransformedBasicRoles | undefined
  >();

  const { data: rolesType } = useGetRoles();

  useEffect(() => {
    addAllRoles(data?.productRoles);
  }, [data]);

  useEffect(() => {
    setSelectedRoleType([allRoles?.responseObj?.role]);

    setUserPermissions(allRoles);
    if (
      allRoles &&
      allRoles?.responseObj?.user_product_access &&
      allRoles.responseObj?.user_product_access[0] &&
      allRoles.responseObj?.user_product_access[0].permissions
    ) {
      setLocalpermissions(
        allRoles.responseObj.user_product_access[0].permissions
      );
    }
  }, [allRoles]);

  return (
    <>
      <VerticalForm>
        <Row gutter={[spacings.middle, spacings.middle]}>
          <Col xs={24} md={24} xl={24}>
            <FormSection title={t("users.tabs.permissions.role")}>
              <RolesSelect
                onChange={(value) => {
                  console.log(value);
                  let tempSelectedRoleType = rolesType?.list.filter(
                    (r: any) => r.code === value
                  );
                  console.log(tempSelectedRoleType);
                  setSelectedRoleType(tempSelectedRoleType);
                }}
                value={
                  selectedRoleType &&
                  selectedRoleType[0] &&
                  selectedRoleType[0].code
                    ? selectedRoleType[0].code
                    : ""
                }
              />
            </FormSection>
          </Col>

          <Col xs={24} md={24} xl={24}>
            <FormSection title={t("users.tabs.permissions.title")}>
              <Col xs={24} md={24} xl={24}>
                {selectedRoleType &&
                  selectedRoleType[0] &&
                  selectedRoleType[0].code === ADMIN && (
                    <Alert
                      message={t("users.tabs.permissions.admin_message")}
                      type="info"
                      withBackground
                      closable={false}
                      //style={{ "width": "100%", "minWidth": "100%" }}
                    />
                  )}
              </Col>

              <Col xs={24} md={24} xl={24}>
                {selectedRoleType &&
                  selectedRoleType[0] &&
                  selectedRoleType[0].code === CUSTOM &&
                  localpermissions &&
                  userPermissions?.product_parent_roles?.map(
                    (parent_role, i) => {
                      return (
                        <CollapseWrapper>
                          <Collapse
                            expandIcon={({ isActive }) => (
                              <Switch
                                checked={
                                  localpermissions &&
                                  localpermissions.find((o: any) => {
                                    return o.code === parent_role.code;
                                  })?.active
                                }
                                onChange={(value, e) => {
                                  let arr =
                                    localpermissions &&
                                    localpermissions.map((o: any) => {
                                      if (o.code === parent_role.code)
                                        o.active = value;

                                      return o;
                                      // return (o.code===parent_role.code);
                                    });

                                  setLocalpermissions(arr);
                                }}
                              />
                            )}
                            //collapsible="disabled"
                            activeKey={
                              localpermissions.find(
                                (obj) =>
                                  obj.code === parent_role.code &&
                                  obj.active === true
                              )?.code ?? ""
                            }
                            //defaultActiveKey={i}
                            //accordion={  true }
                            // style={{ margin: "5px", width: "100%" }}
                          >
                            <Collapse.Panel
                              header={
                                <CollapseHeader
                                  title={parent_role?.name ?? ""}
                                />
                              }
                              key={parent_role?.code ?? ""}

                              //key={i}
                            >
                              <p>
                                <b>
                                  {t(
                                    "users.tabs.permissions.advanced_permissions"
                                  )}
                                </b>
                              </p>
                              <Row gutter={[spacings.middle, spacings.middle]}>
                                {parent_role?.code &&
                                  userPermissions?.product_child_roles &&
                                  userPermissions?.product_child_roles[
                                    parent_role.code
                                  ].map((child_role, key) => {
                                    return (
                                      <>
                                        <Col
                                          xs={24}
                                          md={12}
                                          xl={12}
                                          style={{ padding: "5px 35px" }}
                                          key={child_role?.code ?? ""}
                                        >
                                          {/* {JSON.stringify(child_role)} */}
                                          <Switch
                                            checked={
                                              localpermissions &&
                                              localpermissions.find(
                                                (o: any) => {
                                                  return (
                                                    o.code === child_role.code
                                                  );
                                                }
                                              )?.active
                                            }
                                            onChange={(value, e) => {
                                              let arr =
                                                localpermissions &&
                                                localpermissions.map(
                                                  (o: any) => {
                                                    if (
                                                      o.code === child_role.code
                                                    )
                                                      o.active = value;

                                                    return o;
                                                    // return (o.code===parent_role.code);
                                                  }
                                                );

                                              setLocalpermissions(arr);
                                            }}
                                          />
                                          <span pl-1>
                                            {" "}
                                            {child_role?.name}
                                            {localpermissions.find(
                                              (obj) =>
                                                obj.code === child_role.code
                                            ) &&
                                              child_role?.filter_type ===
                                                "PRODUCT" && (
                                                <>
                                                  {
                                                    <RestrictDivWrapper>
                                                      <p>
                                                        {t(
                                                          "users.tabs.permissions.restrict_custom_product"
                                                        )}
                                                      </p>

                                                      <AllProductSelect
                                                        onChange={(value) => {
                                                          let tempLocalPermissions =
                                                            localpermissions &&
                                                            localpermissions.map(
                                                              (obj) =>
                                                                obj.code ===
                                                                child_role.code
                                                                  ? {
                                                                      ...obj,
                                                                      filter_list:
                                                                        value
                                                                          ? value.toString()
                                                                          : "",
                                                                    }
                                                                  : obj
                                                            );

                                                          setLocalpermissions(
                                                            tempLocalPermissions
                                                          );
                                                        }}
                                                        //value={userPermissionArrayItems.find((obj)=>obj.code===child_role.code)?.filter_list??undefined}
                                                        value={
                                                          localpermissions.find(
                                                            (obj) => {
                                                              return (
                                                                obj.code ===
                                                                child_role.code
                                                              );
                                                            }
                                                          )?.filter_list !== ""
                                                            ? localpermissions
                                                                .find((obj) => {
                                                                  return (
                                                                    obj.code ===
                                                                    child_role.code
                                                                  );
                                                                })
                                                                ?.filter_list?.split(
                                                                  ","
                                                                )
                                                            : []
                                                        }
                                                      />
                                                    </RestrictDivWrapper>
                                                  }
                                                </>
                                              )}
                                            {localpermissions.find(
                                              (obj) =>
                                                obj.code === child_role.code
                                            ) &&
                                              child_role?.filter_type ===
                                                "COUNTRY" && (
                                                <>
                                                  <RestrictDivWrapper>
                                                    <p>
                                                      {t(
                                                        "users.tabs.permissions.restict_by_country_code"
                                                      )}
                                                    </p>

                                                    <AllCountrySelect
                                                      onChange={(value) => {
                                                        let tempLocalpermissions =
                                                          localpermissions.map(
                                                            (obj) =>
                                                              obj.code ===
                                                              child_role.code
                                                                ? {
                                                                    ...obj,
                                                                    filter_list:
                                                                      value
                                                                        ? value.toString()
                                                                        : "",
                                                                  }
                                                                : obj
                                                          );
                                                        setLocalpermissions(
                                                          tempLocalpermissions
                                                        );
                                                      }}
                                                      //value={userPermissionArrayItems.find((obj)=>obj.code===child_role.code)?.filter_list?.split(',')??undefined}

                                                      value={
                                                        localpermissions.find(
                                                          (obj) => {
                                                            return (
                                                              obj.code ===
                                                              child_role.code
                                                            );
                                                          }
                                                        )?.filter_list !== ""
                                                          ? localpermissions
                                                              .find((obj) => {
                                                                return (
                                                                  obj.code ===
                                                                  child_role.code
                                                                );
                                                              })
                                                              ?.filter_list?.split(
                                                                ","
                                                              )
                                                          : []
                                                      }
                                                    />
                                                  </RestrictDivWrapper>
                                                </>
                                              )}
                                          </span>
                                          {/* <span>{child_role?.code == "USERS_COUNTRY_ACCESS_LIST" ? <input type="text" /> : ""}</span> */}
                                        </Col>
                                      </>
                                    );
                                  })}
                              </Row>
                            </Collapse.Panel>
                          </Collapse>
                        </CollapseWrapper>
                      );
                    }
                  )}
              </Col>
            </FormSection>
          </Col>
          <Col xs={24} md={24} xl={24}>
            <UserRoleAssignActionButton
              userIdToAssignUpdateProductRolePermissions={userId}
              allRolesResponseObj={allRoles?.responseObj}
              localPermissions={localpermissions}
              roleType={selectedRoleType}
            />
          </Col>
        </Row>
      </VerticalForm>
    </>
  );
};
